// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Filson_Soft_Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/filson_pro.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Lexend-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/bornbold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Filson Soft";
  src: url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.eot");
  src: url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.eot?#iefix")format("embedded-opentype"),
    url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.woff2")format("woff2"),
    url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.woff")format("woff"),
    url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.ttf")format("truetype"),
    url("https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.svg#Filson Soft")format("svg");
  font-weight: normal;
}

/* @font-face {
  font-family: 'Filson Soft thin';
  src: url("assets/fonts/Filson_Soft_Thin.otf") format('truetype');
  font-weight: normal;
  font-style: normal;
} */

@font-face {
  font-family: 'Filson Soft thin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Filson Pro';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}


/* @font-face {
  font-family: 'Filson Soft';
  src: url("assets/fonts/Filson_Soft_Book.otf") format('truetype');
  font-weight: normal;
  font-style: normal;
} */

@font-face {
  font-family: 'Lexend';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'born-bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

:root {
  --secondary-background-light-color: rgba(0, 149, 104, 0.2);
  --secondary-background-white-color: rgba(255, 255, 255, 1);
  /* Define your hover color here */
}




* {
  box-sizing: border-box;
}

body {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Filson Soft", "born-bold", "Lexend";
}


::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #e2e2e2;
  border-radius: 5px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

:focus-visible {
  outline: none;
}

.dragResizingActive {
  border: 2px solid rgb(202, 202, 202);
  position: relative;
}

.parent-marker {
  position: absolute;
  width: 100%;
  height: 100%;
}

.dragResizingActive>.parent-marker div {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);
}

.dragResizingActive.resizable-draggable {
  /* position: absolute; */
  border: 12px solid transparent;
  background-color: #fff;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);
}

.dragResizingActive>.resizer {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);
  position: absolute;
  z-index: 2;
}

.dragResizingActive>.resizer.top-left {
  top: -16px;
  left: -16px;
  cursor: nwse-resize;
}

.dragResizingActive>.resizer.top {
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.dragResizingActive>.resizer.top-right {
  top: -16px;
  right: -16px;
  cursor: nesw-resize;
}

.dragResizingActive>.resizer.right {
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.dragResizingActive>.resizer.bottom-right {
  bottom: -16px;
  right: -16px;
  cursor: nwse-resize;
}

.dragResizingActive>.resizer.bottom {
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.dragResizingActive>.resizer.bottom-left {
  bottom: -16px;
  left: -16px;
  cursor: nesw-resize;
}

.dragResizingActive>.resizer.left {
  left: -16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.react-draggable:hover,
.resizable-draggable:hover,
.image-placeholder:hover {
  box-shadow: 0 0 0 2px rgba(189, 16, 224, 0.2);
}



.dragResizingActive>.parent-marker>.left-top {
  top: -5px;
  left: -5px;
  cursor: nw-resize;
}

.dragResizingActive>.parent-marker>.right-top {
  top: -5px;
  right: -5px;
  cursor: ne-resize;
}

.dragResizingActive>.parent-marker>.right-bottom {
  bottom: -5px;
  right: -5px;
  cursor: se-resize;
}

.dragResizingActive>.parent-marker>.left-bottom {
  bottom: -5px;
  left: -5px;
  cursor: sw-resize;
}

.dragResizingActive>.parent-marker>.left-center {
  top: 50%;
  left: -5px;
  transform: translateY(-50%);
  cursor: col-resize;
}

.dragResizingActive>.parent-marker>.right-center {
  top: 50%;
  right: -5px;
  transform: translateY(-50%);
  cursor: col-resize;
}

.dragResizingActive>.parent-marker>.top-center {
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  cursor: row-resize;
}

.dragResizingActive>.parent-marker>.bottom-center {
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  cursor: row-resize;
}

.img-contain {
  width: 100px;
  height: 100%;
  object-fit: scale-down;
}

.rsw-ce[contentEditable=true]:empty:not(:focus):before {
  color: grey;
  content: attr(placeholder);
}

/* .custom-lolmenu .custom-menu-item {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.custom-lolmenu .custom-menu-item:hover {
  background-color: var(--secondary-background-light-color);
  color: var(--secondary-background-white-color);
} */


.edit-textarea {
  position: absolute;
  border: 12px solid transparent;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

.text-wrap {
  /* overflow-wrap: normal;
  text-wrap: nowrap; */
}`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gFAAgF;EAChF;;;;wGAIsG;EACtG,mBAAmB;AACrB;;AAEA;;;;;GAKG;;AAEH;EACE,+BAA+B;EAC/B,+DAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;;;;;GAKG;;AAEH;EACE,qBAAqB;EACrB,+DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+DAAwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,0DAA0D;EAC1D,iCAAiC;AACnC;;;;;AAKA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iDAAiD;AACnD;;;AAGA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;;EAGE,6CAA6C;AAC/C;;;;AAIA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;;;;;;GASG;;;AAGH;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;sBACoB;AACtB","sourcesContent":["@font-face {\n  font-family: \"Filson Soft\";\n  src: url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.eot\");\n  src: url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.eot?#iefix\")format(\"embedded-opentype\"),\n    url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.woff2\")format(\"woff2\"),\n    url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.woff\")format(\"woff\"),\n    url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.ttf\")format(\"truetype\"),\n    url(\"https://db.onlinewebfonts.com/t/bab15956435794e3d48309ddf0700b4c.svg#Filson Soft\")format(\"svg\");\n  font-weight: normal;\n}\n\n/* @font-face {\n  font-family: 'Filson Soft thin';\n  src: url(\"assets/fonts/Filson_Soft_Thin.otf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n} */\n\n@font-face {\n  font-family: 'Filson Soft thin';\n  src: url(\"assets/fonts/Filson_Soft_Regular.otf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Filson Pro';\n  src: url(\"assets/fonts/filson_pro.ttf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n/* @font-face {\n  font-family: 'Filson Soft';\n  src: url(\"assets/fonts/Filson_Soft_Book.otf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n} */\n\n@font-face {\n  font-family: 'Lexend';\n  src: url(\"assets/fonts/Lexend-Regular.ttf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'born-bold';\n  src: url(\"assets/fonts/bornbold.ttf\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n:root {\n  --secondary-background-light-color: rgba(0, 149, 104, 0.2);\n  --secondary-background-white-color: rgba(255, 255, 255, 1);\n  /* Define your hover color here */\n}\n\n\n\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Filson Soft\", \"born-bold\", \"Lexend\";\n}\n\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #e2e2e2;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n:focus-visible {\n  outline: none;\n}\n\n.dragResizingActive {\n  border: 2px solid rgb(202, 202, 202);\n  position: relative;\n}\n\n.parent-marker {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.dragResizingActive>.parent-marker div {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #fff;\n  border-radius: 50%;\n  user-select: none;\n  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);\n}\n\n.dragResizingActive.resizable-draggable {\n  /* position: absolute; */\n  border: 12px solid transparent;\n  background-color: #fff;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);\n}\n\n.dragResizingActive>.resizer {\n  width: 10px;\n  height: 10px;\n  background-color: #fff;\n  border-radius: 50%;\n  user-select: none;\n  box-shadow: 0 0 0 2px rgb(99 98 176 / 20%);\n  position: absolute;\n  z-index: 2;\n}\n\n.dragResizingActive>.resizer.top-left {\n  top: -16px;\n  left: -16px;\n  cursor: nwse-resize;\n}\n\n.dragResizingActive>.resizer.top {\n  top: -16px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.dragResizingActive>.resizer.top-right {\n  top: -16px;\n  right: -16px;\n  cursor: nesw-resize;\n}\n\n.dragResizingActive>.resizer.right {\n  right: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.dragResizingActive>.resizer.bottom-right {\n  bottom: -16px;\n  right: -16px;\n  cursor: nwse-resize;\n}\n\n.dragResizingActive>.resizer.bottom {\n  bottom: -16px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: ns-resize;\n}\n\n.dragResizingActive>.resizer.bottom-left {\n  bottom: -16px;\n  left: -16px;\n  cursor: nesw-resize;\n}\n\n.dragResizingActive>.resizer.left {\n  left: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: ew-resize;\n}\n\n.react-draggable:hover,\n.resizable-draggable:hover,\n.image-placeholder:hover {\n  box-shadow: 0 0 0 2px rgba(189, 16, 224, 0.2);\n}\n\n\n\n.dragResizingActive>.parent-marker>.left-top {\n  top: -5px;\n  left: -5px;\n  cursor: nw-resize;\n}\n\n.dragResizingActive>.parent-marker>.right-top {\n  top: -5px;\n  right: -5px;\n  cursor: ne-resize;\n}\n\n.dragResizingActive>.parent-marker>.right-bottom {\n  bottom: -5px;\n  right: -5px;\n  cursor: se-resize;\n}\n\n.dragResizingActive>.parent-marker>.left-bottom {\n  bottom: -5px;\n  left: -5px;\n  cursor: sw-resize;\n}\n\n.dragResizingActive>.parent-marker>.left-center {\n  top: 50%;\n  left: -5px;\n  transform: translateY(-50%);\n  cursor: col-resize;\n}\n\n.dragResizingActive>.parent-marker>.right-center {\n  top: 50%;\n  right: -5px;\n  transform: translateY(-50%);\n  cursor: col-resize;\n}\n\n.dragResizingActive>.parent-marker>.top-center {\n  top: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: row-resize;\n}\n\n.dragResizingActive>.parent-marker>.bottom-center {\n  bottom: -5px;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: row-resize;\n}\n\n.img-contain {\n  width: 100px;\n  height: 100%;\n  object-fit: scale-down;\n}\n\n.rsw-ce[contentEditable=true]:empty:not(:focus):before {\n  color: grey;\n  content: attr(placeholder);\n}\n\n/* .custom-lolmenu .custom-menu-item {\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.custom-lolmenu .custom-menu-item:hover {\n  background-color: var(--secondary-background-light-color);\n  color: var(--secondary-background-white-color);\n} */\n\n\n.edit-textarea {\n  position: absolute;\n  border: 12px solid transparent;\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\n.text-wrap {\n  /* overflow-wrap: normal;\n  text-wrap: nowrap; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
